import { useRouter } from "next/router";
import React, { useContext, useRef, useState, useTransition } from "react";
import { useForm } from "react-hook-form";


import Link from "next/link";
import { Card } from "react-bootstrap";
import AsyncSelect from "react-select/async";


import SettingsLayout from "./SettingsLayout";
const Page = function () {
    const [items, setItems] = useState([])
    const [preview, setPreview] = useState('http://ssl.gstatic.com/accounts/ui/avatar_2x.png')
    const [mobilePreview, setmobilePreview] = useState('http://ssl.gstatic.com/accounts/ui/avatar_2x.png')
    const [showLoader, setShowLoader] = useState(false);
    const editorRef = useRef(null);
    const router = useRouter();
    const queryParams = router.query;
    const [DTvalue, setDTvalue] = useState('');
    const [EndDTvalue, setEndDTvalue] = useState('');
    const {
        register,
        setValue,
        handleSubmit,
        watch,
        formState: { errors, isSubmitting },
        setError,
    } = useForm();

    const onSelectFile = e => {
        console.log(e.target.files[0])
        // I've kept this example simple by usin;g the first image instead of multiple
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setPreview(objectUrl);
        //setValue("avatar", e.target.files[0]);
    }

    const onSelectFileForMobile = e => {
        console.log(e.target.files[0])
        // I've kept this example simple by usin;g the first image instead of multiple
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setmobilePreview(objectUrl);
        //setValue("avatar", e.target.files[0]);
    }

    // const onSubmit = handleSubmit(async (data, event, id) => {
    //     console.log('errorrs', errors)
    //     const formData = new FormData(event.target);

    //     await homepagelayoutcontentModel
    //         .create(formData, queryParams?.id)
    //         .then((response) => {
    //             helper.sweetalert.toast(response.data?.message, 'success');
    //             router.push(`/homepagelayout/${queryParams?.id}/content`);
    //         })
    //         .catch((error) => {
    //             console.log(error.response?.data?.errors);
    //             helper.sweetalert.toast(error.response?.data?.message, 'error');
    //             _.each(error.response?.data?.errors, function (err, errorKey) {
    //                 setError(errorKey, { type: "required", message: err });
    //             });
    //         });
    // });

    // const DTonChange = stat => {
    //     setDTvalue(stat);
    //     console.log("date time select value" + stat);
    // };

    // const EndDTonChange = stat => {
    //     setEndDTvalue(stat);
    //     console.log("date time select value" + stat);
    // };

    return (
        <>
            <SettingsLayout>
                
                <form className="container" method="post" encType='multipart/form-data'>
                    <div className="card col-md-12">
                        <div className="card-header fs-3 ">Create Banner</div>
                        <div className="card-body row">

                            <div className="col-md-6">
                                <img src={preview}
                                    className="w-100 border rounded" alt="" />
                                <div className="m-1">
                                    <label className="custom-file-upload">
                                        <input type="file" className="d-none" accept="image/*" {...register('image', { onChange: onSelectFile })} />
                                        <b className="btn btn-dark">Upload for mobile</b>
                                    </label>

                                </div>

                                <div className="invalid-feedback">
                                    {errors.image && errors.image.message}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <img src={mobilePreview}
                                    className="w-100 border rounded" alt="" />
                                <div className="m-1">
                                    <label className="custom-file-upload">
                                        <input type="file" className="d-none" accept="image/*" {...register('desktop_image', { onChange: onSelectFileForMobile })} />
                                        <b className="btn btn-dark">Upload for desktop</b>
                                    </label>

                                </div>
                                </div>
                                
                        </div>
                        <div className="card-footer">
                            <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className="btn btn-primary float-end">
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </SettingsLayout>
        </>

    );
};

export default Page;
